import { Box, Button, Checkbox, TableCell, TableRow, Typography } from '@mui/material';
import { MyAvatar } from 'src/components/common';

// ----------------------------------------------------------------------

const notificationStyleTypes = [
  { id: 1, title: 'مربعی' },
  { id: 2, title: 'مستطیل افقی' },
  { id: 3, title: 'مستطیل عمودی' },
];

export default function NotificationStyleListTableRow({ row, selected, onSelectRow, onEditRow, onDeleteRow, selectPopupFrame }) {
  const { RowNum, NotificationStyleLable, NotificationStyleImageUrl, NotificationStyleType, NotificationStyleID } = row;

  return (
    <TableRow hover selected={selected}>
      {selectPopupFrame ? null : (
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onClick={onSelectRow} />
        </TableCell>
      )}

      <TableCell align="center">
        <Typography variant="body1">{selectPopupFrame ? RowNum + 1 : RowNum}</Typography>
      </TableCell>

      <TableCell align="center" sx={{ display: 'flex', justifyContent: 'center' }}>
        {NotificationStyleID === -1 ? (
          <Typography variant="body1">-</Typography>
        ) : (
          <MyAvatar alt={NotificationStyleLable} src={NotificationStyleImageUrl} />
        )}
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{NotificationStyleLable}</Typography>
      </TableCell>

      <TableCell align="center">
        {NotificationStyleID === -1 ? (
          <Typography variant="body1">-</Typography>
        ) : (
          <Typography variant="body1">{notificationStyleTypes?.find(({ id }) => id === NotificationStyleType)?.title}</Typography>
        )}
      </TableCell>

      <TableCell align="right">
        <Box sx={{ display: 'inline-flex', gap: 1 }}>
          {selectPopupFrame ? (
            <Button size="small" color="warning" variant="contained" onClick={() => selectPopupFrame(row)}>
              انتخاب
            </Button>
          ) : (
            <>
              <Button size="small" color="info" variant="contained" onClick={onEditRow}>
                ویرایش
              </Button>

              <Button size="small" color="error" variant="contained" onClick={onDeleteRow}>
                حذف
              </Button>
            </>
          )}
        </Box>
      </TableCell>
    </TableRow>
  );
}
